# Site-wide announcement: a bar fixed to the bottom of the screen, clear of
# the top bar and the phone menu button. It hides itself once `endsAt` has
# passed, and a visitor can close it (remembered for the browser session).
# To post a new announcement, change `heading`, `message`, `endsAt` and `storageKey`.
const heading = "Church picnic on Sunday, November 1!"
const message = "There's no service at our church building that day. Instead, we'll gather at O.P. Schnabel Park (9606 Bandera Rd.) for our annual picnic. Come join us!"
const linkLabel = "Details"
const linkRoute = "/posts"
# midnight after the picnic, San Antonio time (CST after Nov 1)
const endsAt = new Date("2026-11-02T00:00:00-06:00")
const storageKey = "dismissed-banner-picnic-2026"

tag announcement-banner
	dismissed = false

	def mount
		try dismissed = sessionStorage.getItem(storageKey) === "1"

	def dismiss
		dismissed = true
		try sessionStorage.setItem(storageKey, "1")

	def go
		imba.router.go(linkRoute)

	<self.announcement-banner>
		if !dismissed and new Date! < endsAt
			<div.bar role="status">
				<i.fa.fa-sun.icon>
				<p.text>
					<strong.heading> heading
					<span> message
					<a.more @click=go> linkLabel
				<button.close @click=dismiss aria-label="Close announcement">
					"×"

css .announcement-banner .bar
	pos:fixed left:0 right:0 bottom:0 zi:1000
	d:flex ai:center gap:.9em
	px:1.25em py:.85em
	bgc:amber1 c:cooler9
	bdt:3px solid amber5
	box-shadow:0 -4px 16px rgba(0,0,0,.15)
	.icon c:amber6 fs:1.4em fls:0
	.text
		flex:1 m:0 fs:1em lh:1.4
		fs@lt-md:.95em
	.heading
		mr:.4em fw:800 c:red7
	.more
		ml:.5em fw:700 c:red7 td:underline cursor:pointer ws:nowrap
	.close
		fls:0 bgc:transparent @hover:amber2 bd:none rd:full
		w:2em h:2em c:cooler7 fs:1.5em lh:1 cursor:pointer
